import {
	API_ADMIN_GET_ALL_LOG,
	API_ADMIN_GET_ALL_LOG_FAIL,
	API_ADMIN_GET_ALL_LOG_SUCCESS,
	API_ADMIN_GET_FOLDER_LOG,
	API_ADMIN_GET_FOLDER_LOG_FAIL,
	API_ADMIN_GET_FOLDER_LOG_SUCCESS,
	ADMIN_RESET_LOGS,
} from '../actions/log';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
};

const logs = createReducer(initialState, {
	[ADMIN_RESET_LOGS]: (state, action) => {
		state.loading = false;
		state.list = [];
	},

	/** GET ALL **/
	[API_ADMIN_GET_ALL_LOG]: (state, action) => {
		state.loading = true;
	},
	[API_ADMIN_GET_ALL_LOG_FAIL]: (state, action) => {
		errorHandler('Logs', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_ADMIN_GET_ALL_LOG_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},

	/** GET FOLDER **/
	[API_ADMIN_GET_FOLDER_LOG]: (state, action) => {
		state.loading = true;
	},
	[API_ADMIN_GET_FOLDER_LOG_FAIL]: (state, action) => {
		errorHandler('Logs', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_ADMIN_GET_FOLDER_LOG_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default logs;
